import { captureException, captureMessage, init, setTags } from '@sentry/browser'
import { botDetectionService, isE2eTest } from '@src/helpers/env'

export function initSentry(): void {
  init({
    dsn: process.env['SENTRY_DSN'] || undefined,
    release: process.env['GATSBY_VERSION_NUMBER'],
    environment: process.env['GATSBY_ENV'],
    sampleRate: 0.01, // until we fix the bulk of most common errors
    // serverName: '123',
    // whitelistUrls: [],
    denyUrls: [
      /localhost/,
      /127\.0\.0\.1/,

      // The following list comes from: https://docs.sentry.io/clients/javascript/tips/
      // Facebook flakiness
      /graph\.facebook\.com/i,
      // Facebook blocked
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Woopra flakiness
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      // Other plugins
      /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    ],
    ignoreErrors: [
      // The following list comes from: https://docs.sentry.io/clients/javascript/tips/
      // Random plugins/extensions
      'top.GLOBALS',
      // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      "Can't find variable: ZiteReader",
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      // Facebook borked
      'fb_xd_fragment',
      // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
      // reduce this. (thanks @acdha)
      // See http://stackoverflow.com/questions/4113268
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
      'conduitPage',

      // We had these scpixel errors spamming our Sentry for over a year.
      // Whatever this is, it's related to the Snapchat tracking pixel and
      // none of the marketing folks who use that pixel have raised any
      // concerns about its data quality in that time. So we're going to
      // try to ignore it now!
      // https://sentry.io/organizations/naturalcycles/issues/1798902459
      'scpixel is not defined', // Chrome
      "Can't find variable: scpixel", // Safari
      // Kirill: this is a conflict between CookieBot and analytics.js
      "property 'readyState' of null",
      "evaluating 'g.readyState'",
      'g is null', // same, but from Firefox
    ],
    // debug: true,
  })

  setTags({
    botReason: botDetectionService.getBotReason(),
    cdp: botDetectionService.isCDP(),
    e2e: isE2eTest(),
  })
}

const sentry = {
  captureException,
  captureMessage,
}

export { sentry }
